import styled from 'styled-components';

export const FormModalContainer = styled.div`
    width: 569px;
    padding: 25px 60px;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const FinishButton = styled.button`
    width: 116px;
    height: 39.6px;
    border-radius: 100px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 2px 4px 0 #641221;
    background-image: linear-gradient(to bottom, #ff6b00, #fa2462);
    border: none;
    font-size: 16px;
    color: white;
    weight: bold;
    text-transform: uppercase;
`;

export const SettingRow = styled.div`
    padding: 0 15px;
    width: 100%;
    height: 45px;
    border-bottom: 1px solid #363636;
    border-top: 1px solid #363636;
    display: flex;
    justify-content: space-between;
    align-items: center;
    opacity: ${props => (props.disabled ? 0.25 : 1)};
    transition: all 0.2s ease-in;
`;

export const SettingInput = styled.input`
    width: 75px;
    font-size: 16px;
    color: #8f8e94;
    text-align: right;
    font-weight: 100;
    border: none;
    outline: none;
    background: none;
`;

export const SettingsTimeInput = styled.input`
    width: 25px;
    font-size: 16px;
    color: #8f8e94;
    font-weight: 100;
    text-align: center;
    background-color: #0e0e0e;
    border: none;
    outline: none;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/WorkoutPlanSettingsModal/style.js